import * as React from "react";

import { useLocation, useNavigate } from "react-router-dom";

import "./styles/main.css";

const SingleCaseView = () => {
  const location = useLocation();
  const navigate = useNavigate();
  if (typeof window === `undefined`) {
    return <></>;
  }

  const locationState = location.state as { caseObj?: CaseRenderObj; from?: string } | null;
  let mainURLBase: string = ''
  let imgNum: number = 0;

  if (locationState?.caseObj == null) {
    mainURLBase = "http://img.zocdesign.net/case_img/cases/ux/ux_1_seg";
    imgNum = 1;
  } else {
    mainURLBase = locationState.caseObj.main;
    imgNum = locationState.caseObj.segNum;
  }

  const backPath = locationState?.from ?? (locationState?.caseObj?.type === 'mk' ? '/marketing' : '/ux');

  let urlAry = [];
  for (let i = 1; i <= imgNum; i++) {
    urlAry.push(`${mainURLBase}${i}.jpg`);
  }

  return (
    <div className="page-full">
      <div className="head-single">
        <div className="back link" onClick={() => navigate(backPath)} >
          全部案例
        </div>
      </div>

      <div className="single-case">
        {urlAry.map((url, id) => {
          return (
            <img src={url} alt="" key={id} loading="lazy" style={{ width: "100%", height: "auto" }}></img>
          );
        })}
        <p style={{ fontSize: "8px", color: "rgba(255,255,255,0.25)", padding: "4px", textAlign: "center" }}>
          案例仅作为用户体验设计与咨询成果之展示，相关金融服务与功能最终由持牌金融机构提供并解释
        </p>
      </div>
    </div>
  );
};
export default SingleCaseView;
